import { Route } from "react-router-dom";

import CPTChaserTempZone from "./cptChaserTempZone";
import CPTChaserCPTList from "./cptChaserCPTList";;

export const cptChaserRoutes = ([
    <Route path=":warehouseId/cptChaser" element={<CPTChaserTempZone />} />,
    <Route path=":warehouseId/cptChaser/:tempZone" element={<CPTChaserCPTList />} />,
]);